import React from 'react';
import { BlogHeader } from '../Blog/blog-header';
import { BlogPosts } from '../Blog/blog-posts';
import { FeaturedPosts } from '../Blog/featured-posts';
import { Sidebar } from '../Blog/blog-sidebar';

const BlogPage = () => {
  return (
    <div className="container mx-auto px-4 pt-44 py-8">
      <BlogHeader />
      <div className="flex flex-col md:flex-row gap-8">
        <main className="flex-1">
          <FeaturedPosts />
          <BlogPosts />
        </main>
        <Sidebar className="w-full md:w-1/3" />
      </div>
    </div>
  );
};

export default BlogPage;
